import { useId } from "react";

export default function Logo({ size = 36, wordmark = true, className = "", wordClassName = "" }) {
  const uid = useId().replace(/:/g, "");
  const grad = `st-g-${uid}`;
  const glow = `st-f-${uid}`;

  return (
    <span className={`inline-flex items-center gap-2.5 min-w-0 ${className}`} aria-label="Shoptosa">
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        aria-hidden="true"
        className="shrink-0"
      >
        <defs>
          <linearGradient id={grad} x1="8" y1="4" x2="40" y2="44" gradientUnits="userSpaceOnUse">
            <stop stopColor="#F72585" />
            <stop offset="0.5" stopColor="#C026D3" />
            <stop offset="1" stopColor="#4CC9F0" />
          </linearGradient>
          <filter id={glow} x="-25%" y="-25%" width="150%" height="150%">
            <feGaussianBlur stdDeviation="1.25" result="b" />
            <feMerge>
              <feMergeNode in="b" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
        <rect x="1.25" y="1.25" width="45.5" height="45.5" rx="13" fill="#0B0B0E" />
        <rect x="1.25" y="1.25" width="45.5" height="45.5" rx="13" stroke={`url(#${grad})`} strokeOpacity="0.28" />
        <path
          d="M23.8 8.1c.15-1.85 2.7-2.55 4.35-1.05 1.35 1.2.7 3.15-1 3.75"
          stroke={`url(#${grad})`}
          strokeWidth="3.1"
          strokeLinecap="round"
          fill="none"
          filter={`url(#${glow})`}
        />
        <path
          d="M31.1 14.4c.2-4.2-7.2-6.8-12.4-3.1-4.8 3.3-2.2 8.6 4.1 10.8 5.9 2.1 9.8 6.6 6.6 11.6-3.2 5.1-13.8 5.4-16.6.4"
          stroke={`url(#${grad})`}
          strokeWidth="5.4"
          strokeLinecap="round"
          fill="none"
          filter={`url(#${glow})`}
        />
      </svg>
      {wordmark && (
        <span
          className={`font-serif font-extrabold tracking-tight leading-none whitespace-nowrap text-[22px] ${wordClassName}`}
        >
          Shop<span className="gradient-text">tosa</span>
        </span>
      )}
    </span>
  );
}
